import { render } from "./CarouselControls.vue?vue&type=template&id=6d5fca6a&scoped=true"
import script from "./CarouselControls.vue?vue&type=script&lang=js"
export * from "./CarouselControls.vue?vue&type=script&lang=js"

import "./CarouselControls.vue?vue&type=style&index=0&id=6d5fca6a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d5fca6a"]])

export default __exports__